export function OptionsLaboratorio() {
  const option = [
    { label: "Não precisa de laboratório", value: "Não precisa de laboratório" },
    { label: "Laboratório próprio", value: "Laboratório próprio" },
    { label: "Laboratório parceiros", value: "Laboratório parceiros" },
  ];
  return option;
}
